var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuDriveIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3940_86828)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0557 0H33.4847C15.4015 0 0.742188 14.6593 0.742188 32.7425V87.3135C0.742188 105.397 15.4015 120.056 33.4847 120.056H88.0557C106.139 120.056 120.798 105.397 120.798 87.3135V32.7425C120.798 14.6593 106.139 0 88.0557 0Z",
    fill: "#9C9B9B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3940_86828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 28,
    width: 77,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5703 28.6484H85.5686C92.9696 28.6484 98.9694 34.6482 98.9694 42.0492V78.004C98.9694 85.4051 92.9696 91.4048 85.5686 91.4048H35.9711C28.57 91.4048 22.5703 85.4051 22.5703 78.004V28.6484Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3940_86828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5703 34.9886C22.5703 31.487 25.4089 28.6484 28.9104 28.6484H32.0805H36.8357H49.7217C52.0567 28.6484 53.9496 30.5413 53.9496 32.8763C53.9496 35.065 55.7239 36.8394 57.9127 36.8394H78.6137L90.4172 36.8347C95.1399 36.8328 98.9694 40.6608 98.9694 45.3835V68.5187V78.9178C98.7948 85.797 93.1648 91.4048 86.2833 91.4048H35.2573C28.2505 91.4048 22.5703 85.7247 22.5703 78.7178V34.9886Z",
    fill: "#BABDBB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.1189 32.7422H38.242C35.6144 32.7422 33.4844 34.8723 33.4844 37.4998V73.0054C33.4844 75.633 35.6144 77.7631 38.242 77.7631H90.1189C92.7465 77.7631 94.8766 75.633 94.8766 73.0054V37.4998C94.8766 34.8723 92.7465 32.7422 90.1189 32.7422Z",
    fill: "#CED1D2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3940_86828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuDriveIconInactive);
export default __webpack_public_path__ + "static/media/zunu_drive_icon_inactive.ed716bb4c4ae5adee2e94e65cfbe4c9b.svg";
export { ForwardRef as ReactComponent };